import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getCustomer } from '../Services/stripeService';
import PaymentOptions from './PaymentOptions';
import CustomerDetails from './CustomerDetails';

const PaymentForm = () => {
  const { t } = useTranslation('translations');
  const [customer, setCustomer] = useState(null);
  const [isCustomerLoading, setIsCustomerLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        getCustomer()
          .then((response) => {
            const { data: customer } = response;
            setCustomer(customer);
          })
          .finally(() => {
            setIsCustomerLoading(false);
          });
      } catch (error) {
        console.error('Error fetching CUSTOMER: ', error);
      }
    };

    fetchData();
  }, []);
  // TODO
  // Research why new Stripe customer is being generated every time
  // Implement Stripe "Payment Link"
  // Implement FE error checking
  // Create a FE component for when Stripe user is not created yet
  // Implement nice loading indicator

  return (
    <>
      {isCustomerLoading ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          {customer ? (
            // <FadeIn>
            <CustomerDetails data={customer} />
          ) : (
            // </FadeIn>
            // <FadeIn>
            <PaymentOptions />
            // </FadeIn>
          )}
        </>
      )}
    </>
  );
};

export default PaymentForm;
